import { FormControl, FormGroup } from '@angular/forms';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AccordionService {
    private changes;
    private defaults;
    private listeners = [];

    constructor() {
        this.changes = {};
        this.defaults = {};
    }

    public onAccordionValueChange(fn) {
        this.listeners.push(fn);
    }

    public addFormControl(accordionGroupName: string, formGroup: FormGroup, name: string, defaultValue?: any) {
        const formControl: FormControl = new FormControl(defaultValue);
        if (accordionGroupName) {
            formControl.valueChanges.subscribe(x => {
                if (!this.checkHasDefaultValue(accordionGroupName, name, x)) {
                    const hasValue = this.checkHasValue(x);
                    this.setAccordionControlHasChanges(accordionGroupName, name, hasValue);
                } else {
                    // Else case is required with false value in the case of default
                    // value selection since it is require to make the condition false and
                    // and remove asterisk.
                    this.setAccordionControlHasChanges(accordionGroupName, name, false);
                }
            });

            formGroup.addControl(name, formControl);

            this.registerFormControl(accordionGroupName, defaultValue, name);
        }
    }

    public setAccordionHasChanges(accordionGroupName: string, hasChanges: boolean) {
        const keys = Object.keys(this.changes);
        keys.forEach(accordionControl => {
            if (accordionControl.startsWith(accordionGroupName)) {
                this.changes[accordionControl] = hasChanges;
            }
        });

        this.updateListeners();
    }

    public setAccordionControlHasChanges(accordionGroupName: string, name: string, hasChanges: boolean) {
        const accordionControlName = accordionGroupName + '-' + name;
        if (this.changes && accordionControlName) {
            this.changes[accordionControlName] = hasChanges;
        }

        this.updateListeners();
    }

    public resetChanges(): any {
        const keys = Object.keys(this.changes);
        keys.forEach(accordion => {
            this.changes[accordion] = false;
        });
    }

    private registerDefaultValue(accordionGroupName: string, name: string, defaultValue: any): any {
        const accordionControlName = accordionGroupName + '-' + name;
        if (accordionControlName && defaultValue && !this.checkHasDefaultValue(accordionControlName, name, defaultValue)) {
            this.defaults[accordionControlName] = defaultValue;
        }
    }

    private checkHasDefaultValue(accordionGroupName: string, name: string, value: any): boolean {
        const accordionControlName = accordionGroupName + '-' + name;
        if (accordionControlName && this.defaults[accordionControlName]) {
            return value === this.defaults[accordionControlName];
        }
    }

    private registerFormControl(
        accordionGroupName: string,
        defaultValue: any,
        name: string) {

        this.registerDefaultValue(accordionGroupName, name, defaultValue);
        this.setAccordionControlHasChanges(accordionGroupName, name, false);
    }

    private checkHasValue(value: any): boolean {
        if (value instanceof Array) {
            return value && value.length > 0;
        }

        return value ? true : false;
    }

    private updateListeners() {
        this.listeners.forEach((fn) => fn(this.changes));
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/services/accordion.service.ts